import type { RssPlatform } from '../types/rss'

interface PlatformBadgeProps {
  platform: RssPlatform
}

const platformStyles: Record<RssPlatform, { bg: string; text: string; label: string }> = {
  zenn: { bg: 'bg-blue-100', text: 'text-blue-800', label: 'Zenn' },
  medium: { bg: 'bg-green-100', text: 'text-green-800', label: 'Medium' },
}

export function PlatformBadge({ platform }: PlatformBadgeProps) {
  const style = platformStyles[platform]

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-1 rounded text-xs font-medium ${style.bg} ${style.text}`}>
      {style.label}
      <svg
        className="w-3 h-3"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
        />
      </svg>
    </span>
  )
}
